import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const STORAGE_KEY = "lp_cookie_consent";

const CookieBanner = ({ sectionData }) => {
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const s = (field, def) => {
    const v = sectionData?.[field];
    return v !== undefined && v !== null ? v : def;
  };

  const bgColor = s("bgColor", "#1a1a2e");
  const textColor = s("textColor", "#e5e7eb");
  const btnBgColor = s("btnBgColor", "#2563EB");
  const btnTextColor = s("btnTextColor", "#ffffff");
  const linkColor = s("linkColor", "#60A5FA");
  const message = s("message", "Usamos cookies para melhorar sua experiência.");
  const btnLabel = s("btnLabel", "Aceitar");
  const linkLabel = s("linkLabel", "Política de Privacidade");
  const linkHref = s("linkHref", "/politica-de-privacidade");

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  const handleLink = (e) => {
    e.preventDefault();
    if (!linkHref) return;
    accept();
    setTimeout(() => {
      if (linkHref.startsWith("http") || linkHref.startsWith("//")) {
        window.open(linkHref, "_blank");
      } else {
        history.push(linkHref);
      }
    }, 50);
  };

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: bgColor, color: textColor,
      padding: "8px 14px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      flexWrap: "nowrap", gap: 10,
      boxShadow: "0 -4px 24px rgba(0,0,0,.25)",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    }}>
      <div style={{ flex: 1, minWidth: 0, fontSize: 12.5, lineHeight: 1.3 }}>
        {message}
        {linkLabel && linkHref && (
          <>
            {" "}
            <a
              href={linkHref}
              onClick={handleLink}
              style={{ color: linkColor, textDecoration: "underline", cursor: "pointer" }}
            >
              {linkLabel}
            </a>
            .
          </>
        )}
      </div>
      <button
        onClick={accept}
        style={{
          background: btnBgColor, color: btnTextColor,
          border: "none", borderRadius: 8,
          padding: "8px 18px", fontSize: 13, fontWeight: 600,
          cursor: "pointer", flexShrink: 0,
          fontFamily: "inherit",
          boxShadow: "0 4px 12px rgba(0,0,0,.2)",
          transition: "opacity .15s",
        }}
        onMouseEnter={e => { e.currentTarget.style.opacity = ".85"; }}
        onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
      >
        {btnLabel}
      </button>
    </div>
  );
};

export default CookieBanner;
